module.exports = __webpack_public_path__ + "static/media/Colau_B-comú.0dcee548.png";